// extracted by mini-css-extract-plugin
module.exports = {"root":"Divider_root__BQrbB","withBorder":"Divider_withBorder__NnfR7"};